export default function Presentation() {
    return (
        <section
            data-testid="presentation-section"
            id="presentation"
            className="py-24 md:py-36 border-t border-[#E0E1DD]"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
                    <div className="lg:col-span-3 reveal">
                        <span className="editorial-num text-lg">01</span>
                        <div className="hairline mt-3 pb-3" />
                        <p className="eyebrow mt-4">Présentation</p>
                    </div>

                    <div className="lg:col-span-9">
                        <h2
                            data-testid="presentation-headline"
                            className="reveal h2 text-4xl md:text-5xl lg:text-6xl text-[#0D1B2A] max-w-4xl"
                        >
                            Aoria part d'une idée simple, mais souvent
                            oubliée<span className="text-[#415A77]">.</span>
                        </h2>

                        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
                            <p className="reveal delay-1 text-lg md:text-xl leading-relaxed text-[#1B263B]">
                                Toutes les personnes ne rencontrent pas les
                                mêmes obstacles cognitifs.{" "}
                                <span className="font-serif italic text-[#415A77]">
                                    Et les nouvelles technologies peuvent
                                    contribuer à en réduire une partie.
                                </span>
                            </p>
                            <p className="reveal delay-2 text-base md:text-lg leading-relaxed text-[#5C6B7D]">
                                L'accessibilité cognitive ne concerne pas une
                                minorité isolée. Elle traverse la vie de chacun :
                                troubles neurodéveloppementaux, troubles des
                                apprentissages, vieillissement, maladies,
                                limitations temporaires, fatigue, surcharge,
                                diversité des fonctionnements humains.
                            </p>
                        </div>

                        <blockquote
                            data-testid="presentation-quote"
                            className="reveal delay-3 mt-16 md:mt-20 border-l border-[#0D1B2A] pl-8 md:pl-12 max-w-4xl"
                        >
                            <p className="font-serif text-3xl md:text-4xl lg:text-5xl leading-tight text-[#0D1B2A]">
                                « Ce qui est une difficulté pour quelques-uns
                                est, à un moment ou à un autre, une réalité pour
                                presque tous. »
                            </p>
                            <footer className="mt-6 eyebrow">
                                Simon Marie, président d'Aoria
                            </footer>
                        </blockquote>

                        {/* Organisation — identité institutionnelle */}
                        <div
                            data-testid="organisation-block"
                            className="reveal delay-4 mt-20 md:mt-28 border-t border-[#E0E1DD] pt-12"
                        >
                            <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
                                <div className="md:col-span-4">
                                    <span className="eyebrow">
                                        L'organisation
                                    </span>
                                    <h3 className="h3 mt-4 text-2xl md:text-3xl text-[#0D1B2A]">
                                        Aoria, association
                                        <br />
                                        loi 1901.
                                    </h3>
                                </div>
                                <div className="md:col-span-8">
                                    <p className="text-[#1B263B] text-base md:text-lg leading-relaxed">
                                        Aoria est une association consacrée à
                                        l'accessibilité cognitive. Elle explore
                                        la manière dont les outils numériques
                                        et l'intelligence artificielle peuvent
                                        contribuer à réduire certains obstacles
                                        cognitifs et renforcer l'autonomie dans
                                        les études, le travail et la vie
                                        quotidienne.
                                    </p>
                                    <dl className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-x-6 gap-y-4 text-sm border-t border-[#E0E1DD] pt-6">
                                        <div>
                                            <dt className="eyebrow">Forme</dt>
                                            <dd
                                                data-testid="org-form"
                                                className="mt-2 text-[#1B263B]"
                                            >
                                                Association déclarée loi 1901
                                            </dd>
                                        </div>
                                        <div>
                                            <dt className="eyebrow">SIREN</dt>
                                            <dd
                                                data-testid="org-siren"
                                                className="mt-2 text-[#1B263B] font-mono tracking-wider"
                                            >
                                                993 013 549
                                            </dd>
                                        </div>
                                        <div>
                                            <dt className="eyebrow">Mission</dt>
                                            <dd className="mt-2 text-[#1B263B]">
                                                Accessibilité cognitive à l'ère
                                                numérique
                                            </dd>
                                        </div>
                                    </dl>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
